import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const api = '/api/application-letter/'
const npi = '/api/news/'
const fpi = '/api/form/'
const mpi = '/api/meeting/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const ListApplicationLetter = createAsyncThunk('app-letters', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}list`, params), thunkAPI)
)

export const EditApplicationLetter = createAsyncThunk('app-letter-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${api}edit/${id}`), thunkAPI)
)

export const UpdateApplicationLetter = createAsyncThunk('add-app-letter', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}update`, data), thunkAPI)
)

export const TestApplicationLetter = createAsyncThunk('app-letter-test', (id: string, thunkAPI) =>
  handleRequest(get(`${api}test/${id}`), thunkAPI)
)

export const ListNews = createAsyncThunk('news', (params: {}, thunkAPI) =>
  handleRequest(get(`${npi}list`, params), thunkAPI)
)

export const createNews = createAsyncThunk('add-news', (data: {}, thunkAPI) =>
  handleRequest(post(`${npi}store`, data), thunkAPI)
)

export const editNews = createAsyncThunk('news-edit', (id: string, thunkAPI) =>
  handleRequest(get(`${npi}edit/${id}`), thunkAPI)
)

export const deleteNews = createAsyncThunk('news-destroy', (id: string, thunkAPI) =>
  handleRequest(get(`${npi}destroy/${id}`), thunkAPI)
)

export const GetTypes = createAsyncThunk('news-types', (type: string, thunkAPI) =>
  handleRequest(get(`${npi}get-type/${type}`), thunkAPI)
)

export const toggleNews = createAsyncThunk('news-toggle', (id: string, thunkAPI) =>
  handleRequest(get(`${npi}toggle/${id}`), thunkAPI)
)

export const viewNews = createAsyncThunk('news-view', (id: string, thunkAPI) =>
  handleRequest(get(`${npi}view/${id}`), thunkAPI)
)

export const GetNewsTypes = createAsyncThunk('news-types', (type: string, thunkAPI) =>
  handleRequest(get(`${npi}get-news-type/${type}`), thunkAPI)
)

export const ListArchivedNews = createAsyncThunk('arc-news', (params: {}, thunkAPI) =>
  handleRequest(get(`${npi}archived-list`, params), thunkAPI)
)

export const toggleArchiveNews = createAsyncThunk('news-toggle-archive', (id: string, thunkAPI) =>
  handleRequest(get(`${npi}toggle-archive/${id}`), thunkAPI)
)

export const PrintNews = createAsyncThunk('print-news', (params: {}, thunkAPI) =>
  handleRequest(get(`${npi}print`, params), thunkAPI)
)

export const PrintNewsDetails = createAsyncThunk('print-news-details', (params: {}, thunkAPI) =>
  handleRequest(get(`${npi}print-details`, params), thunkAPI)
)

export const ListForm = createAsyncThunk('forms', (params: {}, thunkAPI) =>
  handleRequest(get(`${fpi}list`, params), thunkAPI)
)

export const createForm = createAsyncThunk('add-form', (data: {}, thunkAPI) =>
  handleRequest(post(`${fpi}store`, data), thunkAPI)
)

export const editForm = createAsyncThunk('edit-form', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}edit/${id}`), thunkAPI)
)

export const deleteForm = createAsyncThunk('destroy-form', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}destroy/${id}`), thunkAPI)
)

export const StdAnnRep = createAsyncThunk('std-ann-rep', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}std-ann-rep/${id}`), thunkAPI)
)

export const StdAnnRepExcel = createAsyncThunk('std-ann-rep-excel', async (id: string) => {
  const response = await axios.get(`/api/form/std-ann-rep-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Annual Evaluation.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const PrintAnnualReport = createAsyncThunk('print-ann-rep', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}print-ann-rep/${id}`), thunkAPI)
)

export const LecAnnRepExcel = createAsyncThunk('lec-ann-rep-excel', async (id: string) => {
  const response = await axios.get(`/api/form/lec-ann-rep-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Annual Evaluation.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const PrintLecAnnReport = createAsyncThunk('prt-lec-ann-rep', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}print-lect-ann-rep/${id}`), thunkAPI)
)

export const StdAnnAy = createAsyncThunk('std-ann-ay', (_, thunkAPI) =>
  handleRequest(get(`${fpi}std-annual-academic-year`), thunkAPI)
)

export const LecAnnAy = createAsyncThunk('lec-ann-ay', (_, thunkAPI) =>
  handleRequest(get(`${fpi}lec-annual-academic-year`), thunkAPI)
)

export const AlmAnnRep = createAsyncThunk('alm-ann-ay', (_, thunkAPI) =>
  handleRequest(get(`${fpi}alm-ann-rep`), thunkAPI)
)

export const LecAnnRep = createAsyncThunk('lec-ann-rep', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}lec-ann-rep/${id}`), thunkAPI)
)

export const GetEvFormTypes = createAsyncThunk('ev-types', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}ev-type-report/${id}`), thunkAPI)
)

export const GetPeerTypes = createAsyncThunk('peer-types', (id: string, thunkAPI) =>
  handleRequest(get(`${fpi}peer-type-report/${id}`), thunkAPI)
)

export const PeerReport = createAsyncThunk('peer-types', (data: {}, thunkAPI) =>
  handleRequest(post(`${fpi}peer-type-report`, data), thunkAPI)
)

export const PeerExcelReport = createAsyncThunk('ev-report-excel', async (id: string) => {
  const response = await axios.get(`/api/form/peer-report-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Peer_Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

// api for meeting
export const AcademicYears = createAsyncThunk('ays', (_, thunkAPI) =>
  handleRequest(get(`${mpi}academic-years`), thunkAPI)
)

export const Semesters = createAsyncThunk('semesters', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}semesters/${id}`), thunkAPI)
)

export const StudentLecturers = createAsyncThunk('sd-lecs', (_, thunkAPI) =>
  handleRequest(get(`${mpi}stds-lecturers`), thunkAPI)
)

export const createMeeting = createAsyncThunk('add-meeting', (data: {}, thunkAPI) =>
  handleRequest(post(`${mpi}store`, data), thunkAPI)
)

export const ListMeetings = createAsyncThunk('meetings', (_, thunkAPI) =>
  handleRequest(get(`${mpi}list`), thunkAPI)
)

export const ArchivedMeetings = createAsyncThunk('arc-meetings', (_, thunkAPI) =>
  handleRequest(get(`${mpi}archived-meetings`), thunkAPI)
)

export const deleteMeeting = createAsyncThunk('destroy-meeting', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}destroy/${id}`), thunkAPI)
)

export const toggleArchiveMeeting = createAsyncThunk('archive-meeting', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}toggle-archive/${id}`), thunkAPI)
)

export const toggleMeetings = createAsyncThunk('toggle-meeting', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}toggle/${id}`), thunkAPI)
)

export const editMeeting = createAsyncThunk('edit-meeting', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}edit/${id}`), thunkAPI)
)

export const editMeetingMinutes = createAsyncThunk('edit-minutes', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}edit-minutes/${id}`), thunkAPI)
)

export const createMeetingMinutes = createAsyncThunk('add-meeting-minute', (data: {}, thunkAPI) =>
  handleRequest(post(`${mpi}minutes`, data), thunkAPI)
)

export const printMeeting = createAsyncThunk('print-meeting', (id: string, thunkAPI) =>
  handleRequest(get(`${mpi}meeting-view/${id}`), thunkAPI)
)

export const createMeetingSubject = createAsyncThunk('add-meeting-subject', (data: {}, thunkAPI) =>
  handleRequest(post(`${mpi}add-subject`, data), thunkAPI)
)

export const meetingOrganizer = createAsyncThunk('organizer', (_, thunkAPI) =>
  handleRequest(get(`${mpi}meeting-organizer`), thunkAPI)
)

export const myMeetings = createAsyncThunk('my-meetings', (_, thunkAPI) =>
  handleRequest(get(`${mpi}my-meetings`), thunkAPI)
)

export const AtdMeeting = createAsyncThunk('atd-meeting', (data: any, thunkAPI) =>
  handleRequest(
    get(`${mpi}attend-meeting`, {
      params: data,
    }),
    thunkAPI
  )
)

type AdminState = {
  record: any
  records: any
  errors: any
}

const initialState: AdminState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListApplicationLetter.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(UpdateApplicationLetter.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListNews.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListArchivedNews.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = adminSlice.actions
export default adminSlice.reducer
